import { JWT_COOKIE_KEY } from '@/constants/constantsAckoDrive';
import Cookies from 'universal-cookie';

interface TokenType {
    access?: string;
    refresh?: string;
}

export class CookieService {
    cookies: Cookies = new Cookies();
    new_tokens: TokenType = {};
    is_reauthenticated: boolean = false;
    is_logged_out: boolean = false;

    constructor(requestHeaderCookie?: string) {
        this.initializeCookies(requestHeaderCookie);
    }

    initializeCookies(requestHeaderCookie?: string): void {
        this.is_reauthenticated = false;
        this.new_tokens = {};
        this.is_logged_out = false;
        if (requestHeaderCookie) {
            this.cookies = new Cookies(requestHeaderCookie);
        } else {
            this.cookies = new Cookies();
        }
    }

    getAccessToken(): string {
        const actual_tokens: TokenType = this.cookies.get(JWT_COOKIE_KEY) || {};
        const access_token = actual_tokens.access || '';
        return access_token;
    }

    getRefreshToken(): string {
        const actual_tokens: TokenType = this.cookies.get(JWT_COOKIE_KEY) || {};
        const refresh_token = actual_tokens.refresh || '';
        return refresh_token;
    }

    isReauthenticated(): boolean {
        return this.is_reauthenticated;
    }

    setIsReauthenticated(tokens: TokenType): void {
        this.new_tokens = tokens;
        this.cookies.set(JWT_COOKIE_KEY, tokens);
        this.is_reauthenticated = true;
    }

    getNewTokens(): TokenType {
        return this.new_tokens;
    }

    setIsLoggedOut(): void {
        this.is_logged_out = true;
        this.cookies.remove(JWT_COOKIE_KEY, { path: '/' });
    }

    isLoggedOut(): boolean {
        return this.is_logged_out;
    }
}
